import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f21bc2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-md-row bd-highlight mb-3" }
const _hoisted_2 = { class: "badge bg-danger" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-grow text-dark spinner-grow-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_4 = { class: "badge bg-danger" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-grow text-warning spinner-grow-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_6 = { class: "badge bg-danger" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-grow text-light spinner-grow-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_8 = { class: "badge bg-danger" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-grow text-light spinner-grow-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table table-striped table-sm" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Order No#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PickUp Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "User"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Driver"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Payment"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Combo"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1))
const _hoisted_14 = { class: "text-nowrap" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "btn-group mr-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { colspan: "12" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Account Type", -1))
const _hoisted_31 = { class: "col-sm-3 text-end" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Business Name ", -1))
const _hoisted_33 = { class: "col-sm-3 text-end" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Total", -1))
const _hoisted_36 = { class: "col-sm-3 text-end" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost", -1))
const _hoisted_38 = { class: "col-sm-3 text-end" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Total Distance ", -1))
const _hoisted_41 = { class: "col-sm-3 text-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Pickup Address ", -1))
const _hoisted_43 = { class: "col-sm-3 text-end" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_46 = { class: "col-sm-9 text-end" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Cancel Note", -1))
const _hoisted_49 = { class: "col-sm-3 text-end" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "is Paid", -1))
const _hoisted_51 = { class: "col-sm-3 text-end" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Tip", -1))
const _hoisted_56 = { class: "col-sm-3 text-end" }
const _hoisted_57 = {
  key: 0,
  class: "row"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Order Id", -1))
const _hoisted_59 = { class: "col-sm-3 text-end" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Order Number", -1))
const _hoisted_61 = { class: "col-sm-3 text-end" }
const _hoisted_62 = {
  key: 1,
  class: "row"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Pickup Distance ", -1))
const _hoisted_64 = { class: "col-sm-3 text-end" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Delivery Distance ", -1))
const _hoisted_66 = { class: "col-sm-3 text-end" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Accepted Date ", -1))
const _hoisted_69 = { class: "col-sm-3 text-end" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Rider Arrived at PickUp ", -1))
const _hoisted_72 = { class: "col-sm-3 text-end" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Collected Date ", -1))
const _hoisted_76 = { class: "col-sm-3 text-end" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Delivered Date ", -1))
const _hoisted_79 = { class: "col-sm-3 text-end" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Order Created Date", -1))
const _hoisted_83 = { class: "col-sm-3 text-end text-nowrap" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Updated Date", -1))
const _hoisted_85 = { class: "col-sm-3 text-end text-nowrap" }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Rider Detail", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_90 = { class: "row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Name", -1))
const _hoisted_92 = { class: "col-sm-3 text-end" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Phone", -1))
const _hoisted_94 = { class: "col-sm-3 text-end" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Email", -1))
const _hoisted_97 = { class: "col-sm-3 text-end" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Img", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "{{order.driver.rider_profile_img}}",
    width: "50"
  })
], -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Payment Detail", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_103 = { class: "row" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Payment Method ", -1))
const _hoisted_105 = { class: "col-sm-3 text-end" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_108 = {
  key: 3,
  class: "row"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Type", -1))
const _hoisted_110 = { class: "col-sm-3 text-end" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Card", -1))
const _hoisted_112 = { class: "col-sm-3 text-end" }
const _hoisted_113 = {
  key: 4,
  class: "row"
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Exp Date", -1))
const _hoisted_115 = { class: "col-sm-3 text-end" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Name", -1))
const _hoisted_117 = { class: "col-sm-3 text-end" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Request Details", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_121 = { class: "row" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request ID", -1))
const _hoisted_123 = { class: "col-sm-3 text-end" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Cost", -1))
const _hoisted_125 = { class: "col-sm-3 text-end" }
const _hoisted_126 = { class: "row" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance", -1))
const _hoisted_128 = { class: "col-sm-3 text-end" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Distance Cost ", -1))
const _hoisted_130 = { class: "col-sm-3 text-end" }
const _hoisted_131 = { class: "row" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package", -1))
const _hoisted_133 = { class: "col-sm-3 text-end" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Package Cost ", -1))
const _hoisted_135 = { class: "col-sm-3 text-end" }
const _hoisted_136 = { class: "row" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Name ", -1))
const _hoisted_138 = { class: "col-sm-3 text-end" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Email ", -1))
const _hoisted_140 = { class: "col-sm-3 text-end" }
const _hoisted_141 = { class: "row" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Phone ", -1))
const _hoisted_143 = { class: "col-sm-3 text-end" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Address ", -1))
const _hoisted_145 = { class: "col-sm-3 text-end" }
const _hoisted_146 = { class: "row" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Courier Note ", -1))
const _hoisted_148 = { class: "col-sm-3 text-end" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Is Delivered ", -1))
const _hoisted_150 = { class: "col-sm-3 text-end" }
const _hoisted_151 = {
  key: 0,
  class: "row"
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Collection Date ", -1))
const _hoisted_153 = { class: "col-sm-3 text-end" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Cash Collection Amount ", -1))
const _hoisted_155 = { class: "col-sm-3 text-end" }
const _hoisted_156 = { class: "row" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request Item Status ", -1))
const _hoisted_158 = { class: "col-sm-3 text-end fw-bold" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end fw-bold" }, null, -1))
const _hoisted_161 = { class: "row" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Delivered Date ", -1))
const _hoisted_163 = { class: "col-sm-3 text-end text-nowrap" }
const _hoisted_164 = { key: 0 }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Action", -1))
const _hoisted_166 = { class: "col-sm-3 text-end" }
const _hoisted_167 = { class: "col-12" }
const _hoisted_168 = { class: "table-responsive" }
const _hoisted_169 = { class: "table table-striped table-sm" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Order No#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PickUp Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "User"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Driver"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Payment"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Combo"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1))
const _hoisted_171 = { class: "text-nowrap" }
const _hoisted_172 = { class: "text-start" }
const _hoisted_173 = { class: "text-start" }
const _hoisted_174 = ["href"]
const _hoisted_175 = { class: "text-start" }
const _hoisted_176 = { class: "text-start" }
const _hoisted_177 = ["href"]
const _hoisted_178 = { class: "text-start" }
const _hoisted_179 = { class: "text-start" }
const _hoisted_180 = { key: 0 }
const _hoisted_181 = { class: "text-start" }
const _hoisted_182 = { key: 0 }
const _hoisted_183 = { class: "btn-group mr-2" }
const _hoisted_184 = ["onClick"]
const _hoisted_185 = { colspan: "12" }
const _hoisted_186 = { class: "row" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Account Type", -1))
const _hoisted_188 = { class: "col-sm-3 text-end" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Business Name ", -1))
const _hoisted_190 = { class: "col-sm-3 text-end" }
const _hoisted_191 = { class: "row" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Total", -1))
const _hoisted_193 = { class: "col-sm-3 text-end" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost", -1))
const _hoisted_195 = { class: "col-sm-3 text-end" }
const _hoisted_196 = { class: "row" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Total Distance ", -1))
const _hoisted_198 = { class: "col-sm-3 text-end" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Pickup Address ", -1))
const _hoisted_200 = { class: "col-sm-3 text-end" }
const _hoisted_201 = { class: "row" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_203 = { class: "col-sm-9 text-end" }
const _hoisted_204 = { class: "row" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Cancel Note", -1))
const _hoisted_206 = { class: "col-sm-3 text-end" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "is Paid", -1))
const _hoisted_208 = { class: "col-sm-3 text-end" }
const _hoisted_209 = { class: "row" }
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Tip", -1))
const _hoisted_213 = { class: "col-sm-3 text-end" }
const _hoisted_214 = {
  key: 0,
  class: "row"
}
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Order Id", -1))
const _hoisted_216 = { class: "col-sm-3 text-end" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Order Number", -1))
const _hoisted_218 = { class: "col-sm-3 text-end" }
const _hoisted_219 = {
  key: 1,
  class: "row"
}
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Pickup Distance ", -1))
const _hoisted_221 = { class: "col-sm-3 text-end" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Delivery Distance ", -1))
const _hoisted_223 = { class: "col-sm-3 text-end" }
const _hoisted_224 = { class: "row" }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Accepted Date ", -1))
const _hoisted_226 = { class: "col-sm-3 text-end" }
const _hoisted_227 = { key: 0 }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Rider Arrived at PickUp ", -1))
const _hoisted_229 = { class: "col-sm-3 text-end" }
const _hoisted_230 = { key: 0 }
const _hoisted_231 = { class: "row" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Collected Date ", -1))
const _hoisted_233 = { class: "col-sm-3 text-end" }
const _hoisted_234 = { key: 0 }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Delivered Date ", -1))
const _hoisted_236 = { class: "col-sm-3 text-end" }
const _hoisted_237 = { key: 0 }
const _hoisted_238 = { class: "row" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Created Date", -1))
const _hoisted_240 = { class: "col-sm-3 text-end" }
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Updated Date", -1))
const _hoisted_242 = { class: "col-sm-3 text-end" }
const _hoisted_243 = { key: 2 }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Rider Detail", -1))
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_247 = { class: "row" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Name", -1))
const _hoisted_249 = { class: "col-sm-3 text-end" }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Phone", -1))
const _hoisted_251 = { class: "col-sm-3 text-end" }
const _hoisted_252 = { class: "row" }
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Email", -1))
const _hoisted_254 = { class: "col-sm-3 text-end" }
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Img", -1))
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "{{order.driver.rider_profile_img}}",
    width: "50"
  })
], -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Payment Detail", -1))
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_260 = { class: "row" }
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Payment Method ", -1))
const _hoisted_262 = { class: "col-sm-3 text-end" }
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_265 = {
  key: 3,
  class: "row"
}
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Type", -1))
const _hoisted_267 = { class: "col-sm-3 text-end" }
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Card", -1))
const _hoisted_269 = { class: "col-sm-3 text-end" }
const _hoisted_270 = {
  key: 4,
  class: "row"
}
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Exp Date", -1))
const _hoisted_272 = { class: "col-sm-3 text-end" }
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Name", -1))
const _hoisted_274 = { class: "col-sm-3 text-end" }
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Request Details", -1))
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_278 = { class: "row" }
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request ID", -1))
const _hoisted_280 = { class: "col-sm-3 text-end" }
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Cost", -1))
const _hoisted_282 = { class: "col-sm-3 text-end" }
const _hoisted_283 = { class: "row" }
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance", -1))
const _hoisted_285 = { class: "col-sm-3 text-end" }
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Distance Cost ", -1))
const _hoisted_287 = { class: "col-sm-3 text-end" }
const _hoisted_288 = { class: "row" }
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package", -1))
const _hoisted_290 = { class: "col-sm-3 text-end" }
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Package Cost ", -1))
const _hoisted_292 = { class: "col-sm-3 text-end" }
const _hoisted_293 = { class: "row" }
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Name ", -1))
const _hoisted_295 = { class: "col-sm-3 text-end" }
const _hoisted_296 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Email ", -1))
const _hoisted_297 = { class: "col-sm-3 text-end" }
const _hoisted_298 = { class: "row" }
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Phone ", -1))
const _hoisted_300 = { class: "col-sm-3 text-end" }
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Address ", -1))
const _hoisted_302 = { class: "col-sm-3 text-end" }
const _hoisted_303 = { class: "row" }
const _hoisted_304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Courier Note ", -1))
const _hoisted_305 = { class: "col-sm-3 text-end" }
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Is Delivered ", -1))
const _hoisted_307 = { class: "col-sm-3 text-end" }
const _hoisted_308 = {
  key: 0,
  class: "row"
}
const _hoisted_309 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Collection Date ", -1))
const _hoisted_310 = { class: "col-sm-3 text-end" }
const _hoisted_311 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Cash Collection Amount ", -1))
const _hoisted_312 = { class: "col-sm-3 text-end" }
const _hoisted_313 = { class: "row" }
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request Item Status ", -1))
const _hoisted_315 = { class: "col-sm-3 text-end fw-bold" }
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_317 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end fw-bold" }, null, -1))
const _hoisted_318 = { class: "row" }
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Delivered Date ", -1))
const _hoisted_320 = { class: "col-sm-3 text-end" }
const _hoisted_321 = { key: 0 }
const _hoisted_322 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Action", -1))
const _hoisted_323 = { class: "col-sm-3 text-end" }
const _hoisted_324 = { class: "col-12" }
const _hoisted_325 = { class: "table-responsive" }
const _hoisted_326 = { class: "table table-striped table-sm" }
const _hoisted_327 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Order No#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PickUp Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "User"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Driver"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Payment"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Combo"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1))
const _hoisted_328 = { class: "text-nowrap" }
const _hoisted_329 = { class: "text-start" }
const _hoisted_330 = { class: "text-start" }
const _hoisted_331 = ["href"]
const _hoisted_332 = { class: "text-start" }
const _hoisted_333 = { class: "text-start" }
const _hoisted_334 = ["href"]
const _hoisted_335 = { class: "text-start" }
const _hoisted_336 = { class: "text-start" }
const _hoisted_337 = { key: 0 }
const _hoisted_338 = { class: "text-start" }
const _hoisted_339 = { key: 0 }
const _hoisted_340 = { class: "btn-group mr-2" }
const _hoisted_341 = ["onClick"]
const _hoisted_342 = { colspan: "12" }
const _hoisted_343 = { class: "row" }
const _hoisted_344 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Account Type", -1))
const _hoisted_345 = { class: "col-sm-3 text-end" }
const _hoisted_346 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Business Name ", -1))
const _hoisted_347 = { class: "col-sm-3 text-end" }
const _hoisted_348 = { class: "row" }
const _hoisted_349 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Total", -1))
const _hoisted_350 = { class: "col-sm-3 text-end" }
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost", -1))
const _hoisted_352 = { class: "col-sm-3 text-end" }
const _hoisted_353 = { class: "row" }
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Total Distance ", -1))
const _hoisted_355 = { class: "col-sm-3 text-end" }
const _hoisted_356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Pickup Address ", -1))
const _hoisted_357 = { class: "col-sm-3 text-end" }
const _hoisted_358 = { class: "row" }
const _hoisted_359 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_360 = { class: "col-sm-9 text-end" }
const _hoisted_361 = { class: "row" }
const _hoisted_362 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Cancel Note", -1))
const _hoisted_363 = { class: "col-sm-3 text-end" }
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "is Paid", -1))
const _hoisted_365 = { class: "col-sm-3 text-end" }
const _hoisted_366 = { class: "row" }
const _hoisted_367 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_368 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_369 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Tip", -1))
const _hoisted_370 = { class: "col-sm-3 text-end" }
const _hoisted_371 = {
  key: 0,
  class: "row"
}
const _hoisted_372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Order Id", -1))
const _hoisted_373 = { class: "col-sm-3 text-end" }
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Order Number", -1))
const _hoisted_375 = { class: "col-sm-3 text-end" }
const _hoisted_376 = {
  key: 1,
  class: "row"
}
const _hoisted_377 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Pickup Distance ", -1))
const _hoisted_378 = { class: "col-sm-3 text-end" }
const _hoisted_379 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Delivery Distance ", -1))
const _hoisted_380 = { class: "col-sm-3 text-end" }
const _hoisted_381 = { class: "row" }
const _hoisted_382 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Accepted Date ", -1))
const _hoisted_383 = { class: "col-sm-3 text-end" }
const _hoisted_384 = { key: 0 }
const _hoisted_385 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Rider Arrived at PickUp ", -1))
const _hoisted_386 = { class: "col-sm-3 text-end" }
const _hoisted_387 = { key: 0 }
const _hoisted_388 = { class: "row" }
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Collected Date ", -1))
const _hoisted_390 = { class: "col-sm-3 text-end" }
const _hoisted_391 = { key: 0 }
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Delivered Date ", -1))
const _hoisted_393 = { class: "col-sm-3 text-end" }
const _hoisted_394 = { key: 0 }
const _hoisted_395 = { class: "row" }
const _hoisted_396 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Created Date", -1))
const _hoisted_397 = { class: "col-sm-3 text-end" }
const _hoisted_398 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Updated Date", -1))
const _hoisted_399 = { class: "col-sm-3 text-end" }
const _hoisted_400 = { key: 2 }
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_402 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Rider Detail", -1))
const _hoisted_403 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_404 = { class: "row" }
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Name", -1))
const _hoisted_406 = { class: "col-sm-3 text-end" }
const _hoisted_407 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Phone", -1))
const _hoisted_408 = { class: "col-sm-3 text-end" }
const _hoisted_409 = { class: "row" }
const _hoisted_410 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Email", -1))
const _hoisted_411 = { class: "col-sm-3 text-end" }
const _hoisted_412 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Img", -1))
const _hoisted_413 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "{{order.driver.rider_profile_img}}",
    width: "50"
  })
], -1))
const _hoisted_414 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_415 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Payment Detail", -1))
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_417 = { class: "row" }
const _hoisted_418 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Payment Method ", -1))
const _hoisted_419 = { class: "col-sm-3 text-end" }
const _hoisted_420 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_421 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_422 = {
  key: 3,
  class: "row"
}
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Type", -1))
const _hoisted_424 = { class: "col-sm-3 text-end" }
const _hoisted_425 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Card", -1))
const _hoisted_426 = { class: "col-sm-3 text-end" }
const _hoisted_427 = {
  key: 4,
  class: "row"
}
const _hoisted_428 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Exp Date", -1))
const _hoisted_429 = { class: "col-sm-3 text-end" }
const _hoisted_430 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Name", -1))
const _hoisted_431 = { class: "col-sm-3 text-end" }
const _hoisted_432 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Request Details", -1))
const _hoisted_434 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_435 = { class: "row" }
const _hoisted_436 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request ID", -1))
const _hoisted_437 = { class: "col-sm-3 text-end" }
const _hoisted_438 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Cost", -1))
const _hoisted_439 = { class: "col-sm-3 text-end" }
const _hoisted_440 = { class: "row" }
const _hoisted_441 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance", -1))
const _hoisted_442 = { class: "col-sm-3 text-end" }
const _hoisted_443 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Distance Cost ", -1))
const _hoisted_444 = { class: "col-sm-3 text-end" }
const _hoisted_445 = { class: "row" }
const _hoisted_446 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package", -1))
const _hoisted_447 = { class: "col-sm-3 text-end" }
const _hoisted_448 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Package Cost ", -1))
const _hoisted_449 = { class: "col-sm-3 text-end" }
const _hoisted_450 = { class: "row" }
const _hoisted_451 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Name ", -1))
const _hoisted_452 = { class: "col-sm-3 text-end" }
const _hoisted_453 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Email ", -1))
const _hoisted_454 = { class: "col-sm-3 text-end" }
const _hoisted_455 = { class: "row" }
const _hoisted_456 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Phone ", -1))
const _hoisted_457 = { class: "col-sm-3 text-end" }
const _hoisted_458 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Address ", -1))
const _hoisted_459 = { class: "col-sm-3 text-end" }
const _hoisted_460 = { class: "row" }
const _hoisted_461 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Courier Note ", -1))
const _hoisted_462 = { class: "col-sm-3 text-end" }
const _hoisted_463 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Is Delivered ", -1))
const _hoisted_464 = { class: "col-sm-3 text-end" }
const _hoisted_465 = {
  key: 0,
  class: "row"
}
const _hoisted_466 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Collection Date ", -1))
const _hoisted_467 = { class: "col-sm-3 text-end" }
const _hoisted_468 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Cash Collection Amount ", -1))
const _hoisted_469 = { class: "col-sm-3 text-end" }
const _hoisted_470 = { class: "row" }
const _hoisted_471 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request Item Status ", -1))
const _hoisted_472 = { class: "col-sm-3 text-end fw-bold" }
const _hoisted_473 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_474 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end fw-bold" }, null, -1))
const _hoisted_475 = { class: "row" }
const _hoisted_476 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Delivered Date ", -1))
const _hoisted_477 = { class: "col-sm-3 text-end" }
const _hoisted_478 = { key: 0 }
const _hoisted_479 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Action", -1))
const _hoisted_480 = { class: "col-sm-3 text-end" }
const _hoisted_481 = { class: "col-12" }
const _hoisted_482 = { class: "table-responsive" }
const _hoisted_483 = { class: "table table-striped table-sm" }
const _hoisted_484 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Order No#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PickUp Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "User"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Driver"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Payment"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Combo"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1))
const _hoisted_485 = { class: "text-nowrap" }
const _hoisted_486 = { class: "text-start" }
const _hoisted_487 = { class: "text-start" }
const _hoisted_488 = ["href"]
const _hoisted_489 = { class: "text-start" }
const _hoisted_490 = { class: "text-start" }
const _hoisted_491 = ["href"]
const _hoisted_492 = { class: "text-start" }
const _hoisted_493 = { class: "text-start" }
const _hoisted_494 = { key: 0 }
const _hoisted_495 = { class: "text-start" }
const _hoisted_496 = { key: 0 }
const _hoisted_497 = { class: "btn-group mr-2" }
const _hoisted_498 = ["onClick"]
const _hoisted_499 = { colspan: "12" }
const _hoisted_500 = { class: "row" }
const _hoisted_501 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Account Type", -1))
const _hoisted_502 = { class: "col-sm-3 text-end" }
const _hoisted_503 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Business Name ", -1))
const _hoisted_504 = { class: "col-sm-3 text-end" }
const _hoisted_505 = { class: "row" }
const _hoisted_506 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Total", -1))
const _hoisted_507 = { class: "col-sm-3 text-end" }
const _hoisted_508 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost", -1))
const _hoisted_509 = { class: "col-sm-3 text-end" }
const _hoisted_510 = { class: "row" }
const _hoisted_511 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Total Distance ", -1))
const _hoisted_512 = { class: "col-sm-3 text-end" }
const _hoisted_513 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Pickup Address ", -1))
const _hoisted_514 = { class: "col-sm-3 text-end" }
const _hoisted_515 = { class: "row" }
const _hoisted_516 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_517 = { class: "col-sm-9 text-end" }
const _hoisted_518 = { class: "row" }
const _hoisted_519 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Cancel Note", -1))
const _hoisted_520 = { class: "col-sm-3 text-end" }
const _hoisted_521 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "is Paid", -1))
const _hoisted_522 = { class: "col-sm-3 text-end" }
const _hoisted_523 = { class: "row" }
const _hoisted_524 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_525 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_526 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Tip", -1))
const _hoisted_527 = { class: "col-sm-3 text-end" }
const _hoisted_528 = {
  key: 0,
  class: "row"
}
const _hoisted_529 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Order Id", -1))
const _hoisted_530 = { class: "col-sm-3 text-end" }
const _hoisted_531 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Order Number", -1))
const _hoisted_532 = { class: "col-sm-3 text-end" }
const _hoisted_533 = {
  key: 1,
  class: "row"
}
const _hoisted_534 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Pickup Distance ", -1))
const _hoisted_535 = { class: "col-sm-3 text-end" }
const _hoisted_536 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Delivery Distance ", -1))
const _hoisted_537 = { class: "col-sm-3 text-end" }
const _hoisted_538 = { class: "row" }
const _hoisted_539 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Accepted Date ", -1))
const _hoisted_540 = { class: "col-sm-3 text-end" }
const _hoisted_541 = { key: 0 }
const _hoisted_542 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Rider Arrived at PickUp ", -1))
const _hoisted_543 = { class: "col-sm-3 text-end" }
const _hoisted_544 = { key: 0 }
const _hoisted_545 = { class: "row" }
const _hoisted_546 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Collected Date ", -1))
const _hoisted_547 = { class: "col-sm-3 text-end" }
const _hoisted_548 = { key: 0 }
const _hoisted_549 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Delivered Date ", -1))
const _hoisted_550 = { class: "col-sm-3 text-end" }
const _hoisted_551 = { key: 0 }
const _hoisted_552 = { class: "row" }
const _hoisted_553 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Created Date", -1))
const _hoisted_554 = { class: "col-sm-3 text-end" }
const _hoisted_555 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Updated Date", -1))
const _hoisted_556 = { class: "col-sm-3 text-end" }
const _hoisted_557 = { key: 2 }
const _hoisted_558 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_559 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Rider Detail", -1))
const _hoisted_560 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_561 = { class: "row" }
const _hoisted_562 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Name", -1))
const _hoisted_563 = { class: "col-sm-3 text-end" }
const _hoisted_564 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Phone", -1))
const _hoisted_565 = { class: "col-sm-3 text-end" }
const _hoisted_566 = { class: "row" }
const _hoisted_567 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Email", -1))
const _hoisted_568 = { class: "col-sm-3 text-end" }
const _hoisted_569 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Img", -1))
const _hoisted_570 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "{{order.driver.rider_profile_img}}",
    width: "50"
  })
], -1))
const _hoisted_571 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_572 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Payment Detail", -1))
const _hoisted_573 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_574 = { class: "row" }
const _hoisted_575 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Payment Method ", -1))
const _hoisted_576 = { class: "col-sm-3 text-end" }
const _hoisted_577 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_578 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_579 = {
  key: 3,
  class: "row"
}
const _hoisted_580 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Type", -1))
const _hoisted_581 = { class: "col-sm-3 text-end" }
const _hoisted_582 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Card", -1))
const _hoisted_583 = { class: "col-sm-3 text-end" }
const _hoisted_584 = {
  key: 4,
  class: "row"
}
const _hoisted_585 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Exp Date", -1))
const _hoisted_586 = { class: "col-sm-3 text-end" }
const _hoisted_587 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Name", -1))
const _hoisted_588 = { class: "col-sm-3 text-end" }
const _hoisted_589 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_590 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Request Details", -1))
const _hoisted_591 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_592 = { class: "row" }
const _hoisted_593 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request ID", -1))
const _hoisted_594 = { class: "col-sm-3 text-end" }
const _hoisted_595 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Cost", -1))
const _hoisted_596 = { class: "col-sm-3 text-end" }
const _hoisted_597 = { class: "row" }
const _hoisted_598 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Distance Type ", -1))
const _hoisted_599 = { class: "col-sm-3 text-end" }
const _hoisted_600 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Distance Cost ", -1))
const _hoisted_601 = { class: "col-sm-3 text-end" }
const _hoisted_602 = { class: "row" }
const _hoisted_603 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package", -1))
const _hoisted_604 = { class: "col-sm-3 text-end" }
const _hoisted_605 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Package Cost ", -1))
const _hoisted_606 = { class: "col-sm-3 text-end" }
const _hoisted_607 = { class: "row" }
const _hoisted_608 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Name ", -1))
const _hoisted_609 = { class: "col-sm-3 text-end" }
const _hoisted_610 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Email ", -1))
const _hoisted_611 = { class: "col-sm-3 text-end" }
const _hoisted_612 = { class: "row" }
const _hoisted_613 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Phone ", -1))
const _hoisted_614 = { class: "col-sm-3 text-end" }
const _hoisted_615 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Customer Address ", -1))
const _hoisted_616 = { class: "col-sm-3 text-end" }
const _hoisted_617 = { class: "row" }
const _hoisted_618 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Courier Note ", -1))
const _hoisted_619 = { class: "col-sm-3 text-end" }
const _hoisted_620 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Is Delivered ", -1))
const _hoisted_621 = { class: "col-sm-3 text-end" }
const _hoisted_622 = {
  key: 0,
  class: "row"
}
const _hoisted_623 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Collection Date ", -1))
const _hoisted_624 = { class: "col-sm-3 text-end" }
const _hoisted_625 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Cash Collection Amount ", -1))
const _hoisted_626 = { class: "col-sm-3 text-end" }
const _hoisted_627 = { class: "row" }
const _hoisted_628 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request Item Status ", -1))
const _hoisted_629 = { class: "col-sm-3 text-end fw-bold" }
const _hoisted_630 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_631 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end fw-bold" }, null, -1))
const _hoisted_632 = { class: "row" }
const _hoisted_633 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Delivered Date ", -1))
const _hoisted_634 = { class: "col-sm-3 text-end" }
const _hoisted_635 = { key: 0 }
const _hoisted_636 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Action", -1))
const _hoisted_637 = { class: "col-sm-3 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn mb-2 mb-md-0", $setup.activetab == 'liveorders' ? ' btn-primary' : 'btn-secondary']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.btnselecttab('liveorders')))
      }, [
        _createTextVNode(" Live Orders "),
        _createElementVNode("span", _hoisted_2, _toDisplayString($setup.ongoingtotal), 1),
        _hoisted_3
      ], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn mb-2 mb-md-0", $setup.activetab == 'scheduleoders' ? ' btn-primary' : 'btn-secondary']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.btnselecttab('scheduleoders')))
      }, [
        _createTextVNode(" Schedule Orders "),
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.scheduletotal), 1),
        _hoisted_5
      ], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn mb-2 mb-md-0", $setup.activetab == 'deliveredoders' ? ' btn-primary' : 'btn-secondary']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.btnselecttab('deliveredoders')))
      }, [
        _createTextVNode(" Delivered Today "),
        _createElementVNode("span", _hoisted_6, _toDisplayString($setup.completedtotal), 1),
        _hoisted_7
      ], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn mb-2 mb-md-0", $setup.activetab == 'canceloders' ? ' btn-primary' : 'btn-secondary']),
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.btnselecttab('canceloders')))
      }, [
        _createTextVNode(" Cancel Today "),
        _createElementVNode("span", _hoisted_8, _toDisplayString($setup.canceltotal), 1),
        _hoisted_9
      ], 2)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.liveorders, (order) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: order.id
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(order.id), 1),
                  _createElementVNode("td", null, _toDisplayString(order.order_number), 1),
                  _createElementVNode("td", null, _toDisplayString(order.total_price), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString($options.dateTime(order.pickup_date)), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(order.city?.name), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("a", {
                      href: `/users/${order.user?.id}/view`
                    }, _toDisplayString(order.user?.full_name), 9, _hoisted_17)
                  ]),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(order.orderstatus?.name), 1),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("a", {
                      href: `/drivers/${order.driver?.id}/detail`
                    }, _toDisplayString(order.driver?.rider_name), 9, _hoisted_20)
                  ]),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(order.paymentmethod?.name), 1),
                  _createElementVNode("td", _hoisted_22, [
                    (order.is_combine_delivery)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(order.combine_order_id), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    (order.combine_order_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(order.combine_order_number), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-primary me-2",
                        onClick: ($event: any) => ($setup.select(order.id))
                      }, " View", 8, _hoisted_27),
                      (
                      order.orderstatus?.id == 1 ||
                      order.orderstatus?.id == 4 ||
                      order.orderstatus?.id == 5 ||
                      order.orderstatus?.id == 6 ||
                      order.orderstatus?.id == 7 ||
                      order.orderstatus?.id == 8 ||
                      order.orderstatus?.id == 9 ||
                      order.orderstatus?.id == 10
                    )
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/orders/${order.id}/edit`,
                            class: "btn btn-sm btn-secondary me-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Edit ")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["overflow-hidden", $setup.selected === order.id ? 'show' : 'hide'])
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, _toDisplayString(order.user?.account_type), 1),
                        _hoisted_32,
                        _createElementVNode("div", _hoisted_33, _toDisplayString(order.user?.bussiness_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, _toDisplayString(order.total_package_price), 1),
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, _toDisplayString(order.total_distance_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, _toDisplayString(order.total_distance) + " " + _toDisplayString(order.distance_type), 1),
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, _toDisplayString(order.pickup_address), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, _toDisplayString(order.courier_note), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, _toDisplayString(order.cancel_note), 1),
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, _toDisplayString(order.is_paid), 1)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _hoisted_54,
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, _toDisplayString(order.total_rider_tip), 1)
                      ]),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _hoisted_58,
                            _createElementVNode("div", _hoisted_59, _toDisplayString(order.combine_order_id), 1),
                            _hoisted_60,
                            _createElementVNode("div", _hoisted_61, _toDisplayString(order.combine_order_numer), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _hoisted_63,
                            _createElementVNode("div", _hoisted_64, _toDisplayString(order.combine_pickup_distance) + " " + _toDisplayString(order.distance_type), 1),
                            _hoisted_65,
                            _createElementVNode("div", _hoisted_66, _toDisplayString(order.combine_delivery_distance) + " " + _toDisplayString(order.distance_type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_67, [
                        _hoisted_68,
                        _createElementVNode("div", _hoisted_69, [
                          (order.order_accepted_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString($options.dateTime(order.order_accepted_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_71,
                        _createElementVNode("div", _hoisted_72, [
                          (order.arrived_at_pickup_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString($options.dateTime(order.arrived_at_pickup_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("div", _hoisted_76, [
                          (order.order_collected_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString($options.dateTime(order.order_collected_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_78,
                        _createElementVNode("div", _hoisted_79, [
                          (order.order_delivered_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString($options.dateTime(order.order_delivered_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _hoisted_82,
                        _createElementVNode("div", _hoisted_83, _toDisplayString($options.dateTime(order.created_at)), 1),
                        _hoisted_84,
                        _createElementVNode("div", _hoisted_85, _toDisplayString($options.dateTime(order.updated_at)), 1)
                      ]),
                      (order.driver)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                            _hoisted_87,
                            _hoisted_88,
                            _hoisted_89,
                            _createElementVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("div", _hoisted_92, _toDisplayString(order.driver.rider_name), 1),
                              _hoisted_93,
                              _createElementVNode("div", _hoisted_94, _toDisplayString(order.driver.rider_mobile_no), 1)
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _hoisted_96,
                              _createElementVNode("div", _hoisted_97, _toDisplayString(order.driver.rider_email), 1),
                              _hoisted_98,
                              _hoisted_99
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_100,
                      _hoisted_101,
                      _hoisted_102,
                      _createElementVNode("div", _hoisted_103, [
                        _hoisted_104,
                        _createElementVNode("div", _hoisted_105, _toDisplayString(order.paymentmethod?.name), 1),
                        _hoisted_106,
                        _hoisted_107
                      ]),
                      (order.brand)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _hoisted_109,
                            _createElementVNode("div", _hoisted_110, _toDisplayString(order.brand), 1),
                            _hoisted_111,
                            _createElementVNode("div", _hoisted_112, " xxxxxxxxxxxx" + _toDisplayString(order.last4), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.exp_year)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                            _hoisted_114,
                            _createElementVNode("div", _hoisted_115, _toDisplayString(order.exp_month) + "/" + _toDisplayString(order.exp_year), 1),
                            _hoisted_116,
                            _createElementVNode("div", _hoisted_117, _toDisplayString(order.card_name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.order_items, (orderitem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: orderitem.id
                        }, [
                          _hoisted_118,
                          _hoisted_119,
                          _hoisted_120,
                          _createElementVNode("div", _hoisted_121, [
                            _hoisted_122,
                            _createElementVNode("div", _hoisted_123, _toDisplayString(orderitem.id), 1),
                            _hoisted_124,
                            _createElementVNode("div", _hoisted_125, _toDisplayString(orderitem.price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_126, [
                            _hoisted_127,
                            _createElementVNode("div", _hoisted_128, _toDisplayString(orderitem.distance) + " " + _toDisplayString(orderitem.distance_type), 1),
                            _hoisted_129,
                            _createElementVNode("div", _hoisted_130, _toDisplayString(orderitem.distance_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_131, [
                            _hoisted_132,
                            _createElementVNode("div", _hoisted_133, _toDisplayString(orderitem.package?.name), 1),
                            _hoisted_134,
                            _createElementVNode("div", _hoisted_135, _toDisplayString(orderitem.package_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_136, [
                            _hoisted_137,
                            _createElementVNode("div", _hoisted_138, _toDisplayString(orderitem.customer_name), 1),
                            _hoisted_139,
                            _createElementVNode("div", _hoisted_140, _toDisplayString(orderitem.customer_email), 1)
                          ]),
                          _createElementVNode("div", _hoisted_141, [
                            _hoisted_142,
                            _createElementVNode("div", _hoisted_143, _toDisplayString(orderitem.customer_phone), 1),
                            _hoisted_144,
                            _createElementVNode("div", _hoisted_145, _toDisplayString(orderitem.customer_address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_146, [
                            _hoisted_147,
                            _createElementVNode("div", _hoisted_148, _toDisplayString(orderitem.courier_note), 1),
                            _hoisted_149,
                            _createElementVNode("div", _hoisted_150, _toDisplayString(orderitem.is_delivered), 1)
                          ]),
                          (orderitem.is_cash_collection)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                _hoisted_152,
                                _createElementVNode("div", _hoisted_153, _toDisplayString($options.dateTime(orderitem.collection_date)), 1),
                                _hoisted_154,
                                _createElementVNode("div", _hoisted_155, _toDisplayString(orderitem.cash_collection_amount), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_156, [
                            _hoisted_157,
                            _createElementVNode("div", _hoisted_158, _toDisplayString(orderitem.itemstatus?.name), 1),
                            _hoisted_159,
                            _hoisted_160
                          ]),
                          _createElementVNode("div", _hoisted_161, [
                            _hoisted_162,
                            _createElementVNode("div", _hoisted_163, [
                              (orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_164, _toDisplayString($options.dateTime(orderitem.delivered_date)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_165,
                            _createElementVNode("div", _hoisted_166, [
                              _createVNode(_component_router_link, {
                                to: `/orderitems/${orderitem.id}/edit`,
                                class: "btn btn-sm btn-secondary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Edit")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ], 64))
                      }), 128))
                    ], 2)
                  ])
                ])
              ], 64))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, $setup.activetab == 'liveorders']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_167, [
      _createElementVNode("div", _hoisted_168, [
        _createElementVNode("table", _hoisted_169, [
          _hoisted_170,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scheduleorders, (order) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: order.id
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(order.id), 1),
                  _createElementVNode("td", null, _toDisplayString(order.order_number), 1),
                  _createElementVNode("td", null, _toDisplayString(order.total_price), 1),
                  _createElementVNode("td", _hoisted_171, _toDisplayString($options.dateTime(order.pickup_date)), 1),
                  _createElementVNode("td", _hoisted_172, _toDisplayString(order.city?.name), 1),
                  _createElementVNode("td", _hoisted_173, [
                    _createElementVNode("a", {
                      href: `/users/${order.user?.id}/view`
                    }, _toDisplayString(order.user?.full_name), 9, _hoisted_174)
                  ]),
                  _createElementVNode("td", _hoisted_175, _toDisplayString(order.orderstatus?.name), 1),
                  _createElementVNode("td", _hoisted_176, [
                    _createElementVNode("a", {
                      href: `/drivers/${order.driver?.id}/detail`
                    }, _toDisplayString(order.driver?.rider_name), 9, _hoisted_177)
                  ]),
                  _createElementVNode("td", _hoisted_178, _toDisplayString(order.paymentmethod?.name), 1),
                  _createElementVNode("td", _hoisted_179, [
                    (order.is_combine_delivery)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_180, _toDisplayString(order.combine_order_id), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_181, [
                    (order.combine_order_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_182, _toDisplayString(order.combine_order_number), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_183, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-primary me-2",
                        onClick: ($event: any) => ($setup.select(order.id))
                      }, " View", 8, _hoisted_184),
                      (
                      order.orderstatus?.id == 1 ||
                      order.orderstatus?.id == 4 ||
                      order.orderstatus?.id == 5 ||
                      order.orderstatus?.id == 6 ||
                      order.orderstatus?.id == 7 ||
                      order.orderstatus?.id == 8 ||
                      order.orderstatus?.id == 9 ||
                      order.orderstatus?.id == 10
                    )
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/orders/${order.id}/edit`,
                            class: "btn btn-sm btn-secondary me-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Edit ")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_185, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["overflow-hidden", $setup.selected === order.id ? 'show' : 'hide'])
                    }, [
                      _createElementVNode("div", _hoisted_186, [
                        _hoisted_187,
                        _createElementVNode("div", _hoisted_188, _toDisplayString(order.user?.account_type), 1),
                        _hoisted_189,
                        _createElementVNode("div", _hoisted_190, _toDisplayString(order.user?.bussiness_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_191, [
                        _hoisted_192,
                        _createElementVNode("div", _hoisted_193, _toDisplayString(order.total_package_price), 1),
                        _hoisted_194,
                        _createElementVNode("div", _hoisted_195, _toDisplayString(order.total_distance_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_196, [
                        _hoisted_197,
                        _createElementVNode("div", _hoisted_198, _toDisplayString(order.total_distance) + " " + _toDisplayString(order.distance_type), 1),
                        _hoisted_199,
                        _createElementVNode("div", _hoisted_200, _toDisplayString(order.pickup_address), 1)
                      ]),
                      _createElementVNode("div", _hoisted_201, [
                        _hoisted_202,
                        _createElementVNode("div", _hoisted_203, _toDisplayString(order.courier_note), 1)
                      ]),
                      _createElementVNode("div", _hoisted_204, [
                        _hoisted_205,
                        _createElementVNode("div", _hoisted_206, _toDisplayString(order.cancel_note), 1),
                        _hoisted_207,
                        _createElementVNode("div", _hoisted_208, _toDisplayString(order.is_paid), 1)
                      ]),
                      _createElementVNode("div", _hoisted_209, [
                        _hoisted_210,
                        _hoisted_211,
                        _hoisted_212,
                        _createElementVNode("div", _hoisted_213, _toDisplayString(order.total_rider_tip), 1)
                      ]),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                            _hoisted_215,
                            _createElementVNode("div", _hoisted_216, _toDisplayString(order.combine_order_id), 1),
                            _hoisted_217,
                            _createElementVNode("div", _hoisted_218, _toDisplayString(order.combine_order_numer), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                            _hoisted_220,
                            _createElementVNode("div", _hoisted_221, _toDisplayString(order.combine_pickup_distance) + " " + _toDisplayString(order.distance_type), 1),
                            _hoisted_222,
                            _createElementVNode("div", _hoisted_223, _toDisplayString(order.combine_delivery_distance) + " " + _toDisplayString(order.distance_type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_224, [
                        _hoisted_225,
                        _createElementVNode("div", _hoisted_226, [
                          (order.order_accepted_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_227, _toDisplayString($options.dateTime(order.order_accepted_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_228,
                        _createElementVNode("div", _hoisted_229, [
                          (order.arrived_at_pickup_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_230, _toDisplayString($options.dateTime(order.arrived_at_pickup_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_231, [
                        _hoisted_232,
                        _createElementVNode("div", _hoisted_233, [
                          (order.order_collected_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_234, _toDisplayString($options.dateTime(order.order_collected_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_235,
                        _createElementVNode("div", _hoisted_236, [
                          (order.order_delivered_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_237, _toDisplayString($options.dateTime(order.order_delivered_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_238, [
                        _hoisted_239,
                        _createElementVNode("div", _hoisted_240, _toDisplayString($options.dateTime(order.created_at)), 1),
                        _hoisted_241,
                        _createElementVNode("div", _hoisted_242, _toDisplayString($options.dateTime(order.updated_at)), 1)
                      ]),
                      (order.driver)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_243, [
                            _hoisted_244,
                            _hoisted_245,
                            _hoisted_246,
                            _createElementVNode("div", _hoisted_247, [
                              _hoisted_248,
                              _createElementVNode("div", _hoisted_249, _toDisplayString(order.driver.rider_name), 1),
                              _hoisted_250,
                              _createElementVNode("div", _hoisted_251, _toDisplayString(order.driver.rider_mobile_no), 1)
                            ]),
                            _createElementVNode("div", _hoisted_252, [
                              _hoisted_253,
                              _createElementVNode("div", _hoisted_254, _toDisplayString(order.driver.rider_email), 1),
                              _hoisted_255,
                              _hoisted_256
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_257,
                      _hoisted_258,
                      _hoisted_259,
                      _createElementVNode("div", _hoisted_260, [
                        _hoisted_261,
                        _createElementVNode("div", _hoisted_262, _toDisplayString(order.paymentmethod?.name), 1),
                        _hoisted_263,
                        _hoisted_264
                      ]),
                      (order.brand)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                            _hoisted_266,
                            _createElementVNode("div", _hoisted_267, _toDisplayString(order.brand), 1),
                            _hoisted_268,
                            _createElementVNode("div", _hoisted_269, " xxxxxxxxxxxx" + _toDisplayString(order.last4), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.exp_year)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_270, [
                            _hoisted_271,
                            _createElementVNode("div", _hoisted_272, _toDisplayString(order.exp_month) + "/" + _toDisplayString(order.exp_year), 1),
                            _hoisted_273,
                            _createElementVNode("div", _hoisted_274, _toDisplayString(order.card_name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.order_items, (orderitem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: orderitem.id
                        }, [
                          _hoisted_275,
                          _hoisted_276,
                          _hoisted_277,
                          _createElementVNode("div", _hoisted_278, [
                            _hoisted_279,
                            _createElementVNode("div", _hoisted_280, _toDisplayString(orderitem.id), 1),
                            _hoisted_281,
                            _createElementVNode("div", _hoisted_282, _toDisplayString(orderitem.price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_283, [
                            _hoisted_284,
                            _createElementVNode("div", _hoisted_285, _toDisplayString(orderitem.distance) + " " + _toDisplayString(orderitem.distance_type), 1),
                            _hoisted_286,
                            _createElementVNode("div", _hoisted_287, _toDisplayString(orderitem.distance_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_288, [
                            _hoisted_289,
                            _createElementVNode("div", _hoisted_290, _toDisplayString(orderitem.package?.name), 1),
                            _hoisted_291,
                            _createElementVNode("div", _hoisted_292, _toDisplayString(orderitem.package_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_293, [
                            _hoisted_294,
                            _createElementVNode("div", _hoisted_295, _toDisplayString(orderitem.customer_name), 1),
                            _hoisted_296,
                            _createElementVNode("div", _hoisted_297, _toDisplayString(orderitem.customer_email), 1)
                          ]),
                          _createElementVNode("div", _hoisted_298, [
                            _hoisted_299,
                            _createElementVNode("div", _hoisted_300, _toDisplayString(orderitem.customer_phone), 1),
                            _hoisted_301,
                            _createElementVNode("div", _hoisted_302, _toDisplayString(orderitem.customer_address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_303, [
                            _hoisted_304,
                            _createElementVNode("div", _hoisted_305, _toDisplayString(orderitem.courier_note), 1),
                            _hoisted_306,
                            _createElementVNode("div", _hoisted_307, _toDisplayString(orderitem.is_delivered), 1)
                          ]),
                          (orderitem.is_cash_collection)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_308, [
                                _hoisted_309,
                                _createElementVNode("div", _hoisted_310, _toDisplayString($options.dateTime(orderitem.collection_date)), 1),
                                _hoisted_311,
                                _createElementVNode("div", _hoisted_312, _toDisplayString(orderitem.cash_collection_amount), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_313, [
                            _hoisted_314,
                            _createElementVNode("div", _hoisted_315, _toDisplayString(orderitem.itemstatus?.name), 1),
                            _hoisted_316,
                            _hoisted_317
                          ]),
                          _createElementVNode("div", _hoisted_318, [
                            _hoisted_319,
                            _createElementVNode("div", _hoisted_320, [
                              (orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_321, _toDisplayString($options.dateTime(orderitem.delivered_date)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_322,
                            _createElementVNode("div", _hoisted_323, [
                              _createVNode(_component_router_link, {
                                to: `/orderitems/${orderitem.id}/edit`,
                                class: "btn btn-sm btn-secondary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Edit")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ], 64))
                      }), 128))
                    ], 2)
                  ])
                ])
              ], 64))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, $setup.activetab == 'scheduleoders']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_324, [
      _createElementVNode("div", _hoisted_325, [
        _createElementVNode("table", _hoisted_326, [
          _hoisted_327,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.deliveredorders, (order) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: order.id
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(order.id), 1),
                  _createElementVNode("td", null, _toDisplayString(order.order_number), 1),
                  _createElementVNode("td", null, _toDisplayString(order.total_price), 1),
                  _createElementVNode("td", _hoisted_328, _toDisplayString($options.dateTime(order.pickup_date)), 1),
                  _createElementVNode("td", _hoisted_329, _toDisplayString(order.city?.name), 1),
                  _createElementVNode("td", _hoisted_330, [
                    _createElementVNode("a", {
                      href: `/users/${order.user?.id}/view`
                    }, _toDisplayString(order.user?.full_name), 9, _hoisted_331)
                  ]),
                  _createElementVNode("td", _hoisted_332, _toDisplayString(order.orderstatus?.name), 1),
                  _createElementVNode("td", _hoisted_333, [
                    _createElementVNode("a", {
                      href: `/drivers/${order.driver?.id}/detail`
                    }, _toDisplayString(order.driver?.rider_name), 9, _hoisted_334)
                  ]),
                  _createElementVNode("td", _hoisted_335, _toDisplayString(order.paymentmethod?.name), 1),
                  _createElementVNode("td", _hoisted_336, [
                    (order.is_combine_delivery)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_337, _toDisplayString(order.combine_order_id), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_338, [
                    (order.combine_order_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_339, _toDisplayString(order.combine_order_number), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_340, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-primary me-2",
                        onClick: ($event: any) => ($setup.select(order.id))
                      }, " View", 8, _hoisted_341),
                      (
                      order.orderstatus?.id == 1 ||
                      order.orderstatus?.id == 4 ||
                      order.orderstatus?.id == 5 ||
                      order.orderstatus?.id == 6 ||
                      order.orderstatus?.id == 7 ||
                      order.orderstatus?.id == 8 ||
                      order.orderstatus?.id == 9 ||
                      order.orderstatus?.id == 10
                    )
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/orders/${order.id}/edit`,
                            class: "btn btn-sm btn-secondary me-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Edit ")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_342, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["overflow-hidden", $setup.selected === order.id ? 'show' : 'hide'])
                    }, [
                      _createElementVNode("div", _hoisted_343, [
                        _hoisted_344,
                        _createElementVNode("div", _hoisted_345, _toDisplayString(order.user?.account_type), 1),
                        _hoisted_346,
                        _createElementVNode("div", _hoisted_347, _toDisplayString(order.user?.bussiness_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_348, [
                        _hoisted_349,
                        _createElementVNode("div", _hoisted_350, _toDisplayString(order.total_package_price), 1),
                        _hoisted_351,
                        _createElementVNode("div", _hoisted_352, _toDisplayString(order.total_distance_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_353, [
                        _hoisted_354,
                        _createElementVNode("div", _hoisted_355, _toDisplayString(order.total_distance) + " " + _toDisplayString(order.distance_type), 1),
                        _hoisted_356,
                        _createElementVNode("div", _hoisted_357, _toDisplayString(order.pickup_address), 1)
                      ]),
                      _createElementVNode("div", _hoisted_358, [
                        _hoisted_359,
                        _createElementVNode("div", _hoisted_360, _toDisplayString(order.courier_note), 1)
                      ]),
                      _createElementVNode("div", _hoisted_361, [
                        _hoisted_362,
                        _createElementVNode("div", _hoisted_363, _toDisplayString(order.cancel_note), 1),
                        _hoisted_364,
                        _createElementVNode("div", _hoisted_365, _toDisplayString(order.is_paid), 1)
                      ]),
                      _createElementVNode("div", _hoisted_366, [
                        _hoisted_367,
                        _hoisted_368,
                        _hoisted_369,
                        _createElementVNode("div", _hoisted_370, _toDisplayString(order.total_rider_tip), 1)
                      ]),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_371, [
                            _hoisted_372,
                            _createElementVNode("div", _hoisted_373, _toDisplayString(order.combine_order_id), 1),
                            _hoisted_374,
                            _createElementVNode("div", _hoisted_375, _toDisplayString(order.combine_order_numer), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_376, [
                            _hoisted_377,
                            _createElementVNode("div", _hoisted_378, _toDisplayString(order.combine_pickup_distance) + " " + _toDisplayString(order.distance_type), 1),
                            _hoisted_379,
                            _createElementVNode("div", _hoisted_380, _toDisplayString(order.combine_delivery_distance) + " " + _toDisplayString(order.distance_type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_381, [
                        _hoisted_382,
                        _createElementVNode("div", _hoisted_383, [
                          (order.order_accepted_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_384, _toDisplayString($options.dateTime(order.order_accepted_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_385,
                        _createElementVNode("div", _hoisted_386, [
                          (order.arrived_at_pickup_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_387, _toDisplayString($options.dateTime(order.arrived_at_pickup_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_388, [
                        _hoisted_389,
                        _createElementVNode("div", _hoisted_390, [
                          (order.order_collected_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_391, _toDisplayString($options.dateTime(order.order_collected_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_392,
                        _createElementVNode("div", _hoisted_393, [
                          (order.order_delivered_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_394, _toDisplayString($options.dateTime(order.order_delivered_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_395, [
                        _hoisted_396,
                        _createElementVNode("div", _hoisted_397, _toDisplayString($options.dateTime(order.created_at)), 1),
                        _hoisted_398,
                        _createElementVNode("div", _hoisted_399, _toDisplayString($options.dateTime(order.updated_at)), 1)
                      ]),
                      (order.driver)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_400, [
                            _hoisted_401,
                            _hoisted_402,
                            _hoisted_403,
                            _createElementVNode("div", _hoisted_404, [
                              _hoisted_405,
                              _createElementVNode("div", _hoisted_406, _toDisplayString(order.driver.rider_name), 1),
                              _hoisted_407,
                              _createElementVNode("div", _hoisted_408, _toDisplayString(order.driver.rider_mobile_no), 1)
                            ]),
                            _createElementVNode("div", _hoisted_409, [
                              _hoisted_410,
                              _createElementVNode("div", _hoisted_411, _toDisplayString(order.driver.rider_email), 1),
                              _hoisted_412,
                              _hoisted_413
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_414,
                      _hoisted_415,
                      _hoisted_416,
                      _createElementVNode("div", _hoisted_417, [
                        _hoisted_418,
                        _createElementVNode("div", _hoisted_419, _toDisplayString(order.paymentmethod?.name), 1),
                        _hoisted_420,
                        _hoisted_421
                      ]),
                      (order.brand)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_422, [
                            _hoisted_423,
                            _createElementVNode("div", _hoisted_424, _toDisplayString(order.brand), 1),
                            _hoisted_425,
                            _createElementVNode("div", _hoisted_426, " xxxxxxxxxxxx" + _toDisplayString(order.last4), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.exp_year)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_427, [
                            _hoisted_428,
                            _createElementVNode("div", _hoisted_429, _toDisplayString(order.exp_month) + "/" + _toDisplayString(order.exp_year), 1),
                            _hoisted_430,
                            _createElementVNode("div", _hoisted_431, _toDisplayString(order.card_name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.order_items, (orderitem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: orderitem.id
                        }, [
                          _hoisted_432,
                          _hoisted_433,
                          _hoisted_434,
                          _createElementVNode("div", _hoisted_435, [
                            _hoisted_436,
                            _createElementVNode("div", _hoisted_437, _toDisplayString(orderitem.id), 1),
                            _hoisted_438,
                            _createElementVNode("div", _hoisted_439, _toDisplayString(orderitem.price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_440, [
                            _hoisted_441,
                            _createElementVNode("div", _hoisted_442, _toDisplayString(orderitem.distance) + " " + _toDisplayString(orderitem.distance_type), 1),
                            _hoisted_443,
                            _createElementVNode("div", _hoisted_444, _toDisplayString(orderitem.distance_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_445, [
                            _hoisted_446,
                            _createElementVNode("div", _hoisted_447, _toDisplayString(orderitem.package?.name), 1),
                            _hoisted_448,
                            _createElementVNode("div", _hoisted_449, _toDisplayString(orderitem.package_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_450, [
                            _hoisted_451,
                            _createElementVNode("div", _hoisted_452, _toDisplayString(orderitem.customer_name), 1),
                            _hoisted_453,
                            _createElementVNode("div", _hoisted_454, _toDisplayString(orderitem.customer_email), 1)
                          ]),
                          _createElementVNode("div", _hoisted_455, [
                            _hoisted_456,
                            _createElementVNode("div", _hoisted_457, _toDisplayString(orderitem.customer_phone), 1),
                            _hoisted_458,
                            _createElementVNode("div", _hoisted_459, _toDisplayString(orderitem.customer_address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_460, [
                            _hoisted_461,
                            _createElementVNode("div", _hoisted_462, _toDisplayString(orderitem.courier_note), 1),
                            _hoisted_463,
                            _createElementVNode("div", _hoisted_464, _toDisplayString(orderitem.is_delivered), 1)
                          ]),
                          (orderitem.is_cash_collection)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_465, [
                                _hoisted_466,
                                _createElementVNode("div", _hoisted_467, _toDisplayString($options.dateTime(orderitem.collection_date)), 1),
                                _hoisted_468,
                                _createElementVNode("div", _hoisted_469, _toDisplayString(orderitem.cash_collection_amount), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_470, [
                            _hoisted_471,
                            _createElementVNode("div", _hoisted_472, _toDisplayString(orderitem.itemstatus?.name), 1),
                            _hoisted_473,
                            _hoisted_474
                          ]),
                          _createElementVNode("div", _hoisted_475, [
                            _hoisted_476,
                            _createElementVNode("div", _hoisted_477, [
                              (orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_478, _toDisplayString($options.dateTime(orderitem.delivered_date)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_479,
                            _createElementVNode("div", _hoisted_480, [
                              _createVNode(_component_router_link, {
                                to: `/orderitems/${orderitem.id}/edit`,
                                class: "btn btn-sm btn-secondary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Edit")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ], 64))
                      }), 128))
                    ], 2)
                  ])
                ])
              ], 64))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, $setup.activetab == 'deliveredoders']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_481, [
      _createElementVNode("div", _hoisted_482, [
        _createElementVNode("table", _hoisted_483, [
          _hoisted_484,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cancelorders, (order) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: order.id
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(order.id), 1),
                  _createElementVNode("td", null, _toDisplayString(order.order_number), 1),
                  _createElementVNode("td", null, _toDisplayString(order.total_price), 1),
                  _createElementVNode("td", _hoisted_485, _toDisplayString($options.dateTime(order.pickup_date)), 1),
                  _createElementVNode("td", _hoisted_486, _toDisplayString(order.city?.name), 1),
                  _createElementVNode("td", _hoisted_487, [
                    _createElementVNode("a", {
                      href: `/users/${order.user?.id}/view`
                    }, _toDisplayString(order.user?.full_name), 9, _hoisted_488)
                  ]),
                  _createElementVNode("td", _hoisted_489, _toDisplayString(order.orderstatus?.name), 1),
                  _createElementVNode("td", _hoisted_490, [
                    _createElementVNode("a", {
                      href: `/drivers/${order.driver?.id}/detail`
                    }, _toDisplayString(order.driver?.rider_name), 9, _hoisted_491)
                  ]),
                  _createElementVNode("td", _hoisted_492, _toDisplayString(order.paymentmethod?.name), 1),
                  _createElementVNode("td", _hoisted_493, [
                    (order.is_combine_delivery)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_494, _toDisplayString(order.combine_order_id), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_495, [
                    (order.combine_order_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_496, _toDisplayString(order.combine_order_number), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_497, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-primary me-2",
                        onClick: ($event: any) => ($setup.select(order.id))
                      }, " View", 8, _hoisted_498),
                      (
                      order.orderstatus?.id == 1 ||
                      order.orderstatus?.id == 4 ||
                      order.orderstatus?.id == 5 ||
                      order.orderstatus?.id == 6 ||
                      order.orderstatus?.id == 7 ||
                      order.orderstatus?.id == 8 ||
                      order.orderstatus?.id == 9 ||
                      order.orderstatus?.id == 10
                    )
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/orders/${order.id}/edit`,
                            class: "btn btn-sm btn-secondary me-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Edit ")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_499, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["overflow-hidden", $setup.selected === order.id ? 'show' : 'hide'])
                    }, [
                      _createElementVNode("div", _hoisted_500, [
                        _hoisted_501,
                        _createElementVNode("div", _hoisted_502, _toDisplayString(order.user?.account_type), 1),
                        _hoisted_503,
                        _createElementVNode("div", _hoisted_504, _toDisplayString(order.user?.bussiness_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_505, [
                        _hoisted_506,
                        _createElementVNode("div", _hoisted_507, _toDisplayString(order.total_package_price), 1),
                        _hoisted_508,
                        _createElementVNode("div", _hoisted_509, _toDisplayString(order.total_distance_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_510, [
                        _hoisted_511,
                        _createElementVNode("div", _hoisted_512, _toDisplayString(order.total_distance) + " " + _toDisplayString(order.distance_type), 1),
                        _hoisted_513,
                        _createElementVNode("div", _hoisted_514, _toDisplayString(order.pickup_address), 1)
                      ]),
                      _createElementVNode("div", _hoisted_515, [
                        _hoisted_516,
                        _createElementVNode("div", _hoisted_517, _toDisplayString(order.courier_note), 1)
                      ]),
                      _createElementVNode("div", _hoisted_518, [
                        _hoisted_519,
                        _createElementVNode("div", _hoisted_520, _toDisplayString(order.cancel_note), 1),
                        _hoisted_521,
                        _createElementVNode("div", _hoisted_522, _toDisplayString(order.is_paid), 1)
                      ]),
                      _createElementVNode("div", _hoisted_523, [
                        _hoisted_524,
                        _hoisted_525,
                        _hoisted_526,
                        _createElementVNode("div", _hoisted_527, _toDisplayString(order.total_rider_tip), 1)
                      ]),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_528, [
                            _hoisted_529,
                            _createElementVNode("div", _hoisted_530, _toDisplayString(order.combine_order_id), 1),
                            _hoisted_531,
                            _createElementVNode("div", _hoisted_532, _toDisplayString(order.combine_order_numer), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_533, [
                            _hoisted_534,
                            _createElementVNode("div", _hoisted_535, _toDisplayString(order.combine_pickup_distance) + " " + _toDisplayString(order.distance_type), 1),
                            _hoisted_536,
                            _createElementVNode("div", _hoisted_537, _toDisplayString(order.combine_delivery_distance) + " " + _toDisplayString(order.distance_type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_538, [
                        _hoisted_539,
                        _createElementVNode("div", _hoisted_540, [
                          (order.order_accepted_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_541, _toDisplayString($options.dateTime(order.order_accepted_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_542,
                        _createElementVNode("div", _hoisted_543, [
                          (order.arrived_at_pickup_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_544, _toDisplayString($options.dateTime(order.arrived_at_pickup_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_545, [
                        _hoisted_546,
                        _createElementVNode("div", _hoisted_547, [
                          (order.order_collected_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_548, _toDisplayString($options.dateTime(order.order_collected_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_549,
                        _createElementVNode("div", _hoisted_550, [
                          (order.order_delivered_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_551, _toDisplayString($options.dateTime(order.order_delivered_date)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_552, [
                        _hoisted_553,
                        _createElementVNode("div", _hoisted_554, _toDisplayString($options.dateTime(order.created_at)), 1),
                        _hoisted_555,
                        _createElementVNode("div", _hoisted_556, _toDisplayString($options.dateTime(order.updated_at)), 1)
                      ]),
                      (order.driver)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_557, [
                            _hoisted_558,
                            _hoisted_559,
                            _hoisted_560,
                            _createElementVNode("div", _hoisted_561, [
                              _hoisted_562,
                              _createElementVNode("div", _hoisted_563, _toDisplayString(order.driver.rider_name), 1),
                              _hoisted_564,
                              _createElementVNode("div", _hoisted_565, _toDisplayString(order.driver.rider_mobile_no), 1)
                            ]),
                            _createElementVNode("div", _hoisted_566, [
                              _hoisted_567,
                              _createElementVNode("div", _hoisted_568, _toDisplayString(order.driver.rider_email), 1),
                              _hoisted_569,
                              _hoisted_570
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_571,
                      _hoisted_572,
                      _hoisted_573,
                      _createElementVNode("div", _hoisted_574, [
                        _hoisted_575,
                        _createElementVNode("div", _hoisted_576, _toDisplayString(order.paymentmethod?.name), 1),
                        _hoisted_577,
                        _hoisted_578
                      ]),
                      (order.brand)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_579, [
                            _hoisted_580,
                            _createElementVNode("div", _hoisted_581, _toDisplayString(order.brand), 1),
                            _hoisted_582,
                            _createElementVNode("div", _hoisted_583, " xxxxxxxxxxxx" + _toDisplayString(order.last4), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (order.exp_year)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_584, [
                            _hoisted_585,
                            _createElementVNode("div", _hoisted_586, _toDisplayString(order.exp_month) + "/" + _toDisplayString(order.exp_year), 1),
                            _hoisted_587,
                            _createElementVNode("div", _hoisted_588, _toDisplayString(order.card_name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.order_items, (orderitem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: orderitem.id
                        }, [
                          _hoisted_589,
                          _hoisted_590,
                          _hoisted_591,
                          _createElementVNode("div", _hoisted_592, [
                            _hoisted_593,
                            _createElementVNode("div", _hoisted_594, _toDisplayString(orderitem.id), 1),
                            _hoisted_595,
                            _createElementVNode("div", _hoisted_596, _toDisplayString(orderitem.price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_597, [
                            _hoisted_598,
                            _createElementVNode("div", _hoisted_599, _toDisplayString(orderitem.distance) + " " + _toDisplayString(orderitem.distance_type), 1),
                            _hoisted_600,
                            _createElementVNode("div", _hoisted_601, _toDisplayString(orderitem.distance_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_602, [
                            _hoisted_603,
                            _createElementVNode("div", _hoisted_604, _toDisplayString(orderitem.package?.name), 1),
                            _hoisted_605,
                            _createElementVNode("div", _hoisted_606, _toDisplayString(orderitem.package_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_607, [
                            _hoisted_608,
                            _createElementVNode("div", _hoisted_609, _toDisplayString(orderitem.customer_name), 1),
                            _hoisted_610,
                            _createElementVNode("div", _hoisted_611, _toDisplayString(orderitem.customer_email), 1)
                          ]),
                          _createElementVNode("div", _hoisted_612, [
                            _hoisted_613,
                            _createElementVNode("div", _hoisted_614, _toDisplayString(orderitem.customer_phone), 1),
                            _hoisted_615,
                            _createElementVNode("div", _hoisted_616, _toDisplayString(orderitem.customer_address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_617, [
                            _hoisted_618,
                            _createElementVNode("div", _hoisted_619, _toDisplayString(orderitem.courier_note), 1),
                            _hoisted_620,
                            _createElementVNode("div", _hoisted_621, _toDisplayString(orderitem.is_delivered), 1)
                          ]),
                          (orderitem.is_cash_collection)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_622, [
                                _hoisted_623,
                                _createElementVNode("div", _hoisted_624, _toDisplayString($options.dateTime(orderitem.collection_date)), 1),
                                _hoisted_625,
                                _createElementVNode("div", _hoisted_626, _toDisplayString(orderitem.cash_collection_amount), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_627, [
                            _hoisted_628,
                            _createElementVNode("div", _hoisted_629, _toDisplayString(orderitem.itemstatus?.name), 1),
                            _hoisted_630,
                            _hoisted_631
                          ]),
                          _createElementVNode("div", _hoisted_632, [
                            _hoisted_633,
                            _createElementVNode("div", _hoisted_634, [
                              (orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_635, _toDisplayString($options.dateTime(orderitem.delivered_date)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_636,
                            _createElementVNode("div", _hoisted_637, [
                              _createVNode(_component_router_link, {
                                to: `/orderitems/${orderitem.id}/edit`,
                                class: "btn btn-sm btn-secondary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Edit")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ], 64))
                      }), 128))
                    ], 2)
                  ])
                ])
              ], 64))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, $setup.activetab == 'canceloders']
    ])
  ], 64))
}